/**
 * open navigation function depending on user device
 * readMore => https://stackoverflow.com/questions/18739436/how-to-create-a-link-for-all-mobile-devices-that-opens-google-maps-with-a-route
 *
 * with start point (makes sense if the user used before browser localising)
 * https://www.google.com/maps?saddr=My+Location&daddr=760+West+Genesee+Street+Syracuse+NY+13204
 */

import React from 'react'
import PropTypes from 'prop-types'

import { NewTab } from '@aok/icon-functional'
import { Button, Link } from '../'

import * as Styled from './CalculateRouteBtn.styles'

import { useTextContext } from 'hocs'

const CalculateRouteBtn = ({ marker, address, type, navType, className }) => {
  const textContext = useTextContext()

  const handleButtonClick = () => {
    window.open(getMapUrl())
  }

  const userWastMoneyForAppleShit =
    navigator.platform.indexOf('iPhone') !== -1 ||
    navigator.platform.indexOf('iPod') !== -1 ||
    navigator.platform.indexOf('iPad') !== -1

  const getMapUrl = () => {
    let mapsPath = ''
    const devicePath = userWastMoneyForAppleShit ? 'maps' : 'http'

    if (navType === 'geoCoordinates') {
      const { lat, lon } = marker
      mapsPath = `://maps.google.com/maps?daddr=${ lat },${ lon }&amp;ll=`
    } else {
      const { city, zip, street, streetAddition } = address
      mapsPath = `://maps.google.com/?q=${ encodeURI(zip) }+${ encodeURI(
        city
      ) }+${ encodeURI(street) }${
        !!streetAddition ? `+${ encodeURI(streetAddition) }` : ''
      }`
    }

    return `${ devicePath }${ mapsPath }`
  }

  return (
    <Styled.RouteButtonComponent className={ className }>
      {type === 'BUTTON' && (
        <Button
          text={ textContext['general.calculateRoute'] }
          onClick={ handleButtonClick }
          icon={ <NewTab /> }
          className='with-border'
          textFirst
        />
      )}
      {type === 'LINK' && (
        <Link
          icon={ <NewTab /> }
          href={ getMapUrl() }
          iconIsRight
          isNativeLink
          className={ 'link-route' }
          data-cy='maps-link'>
          {textContext['general.calculateRoute']}
        </Link>
      )}
    </Styled.RouteButtonComponent>
  )
}

CalculateRouteBtn.defaultProps = {
  type: 'BUTTON',
  navType: 'geoCoordinates',
}

CalculateRouteBtn.propTypes = {
  /** marker with position data for navigation function **/
  marker: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number,
  }),
  /** required for address based navigation **/
  address: PropTypes.shape({
    city: PropTypes.string,
    street: PropTypes.string,
    streetAddition: PropTypes.string,
    zip: PropTypes.string,
  }),
  /** component type **/
  type: PropTypes.oneOf(['BUTTON', 'LINK']),
  /** source data for navigation **/
  navType: PropTypes.oneOf(['geoCoordinates', 'address']),
}

export default CalculateRouteBtn
